import { Link } from 'react-router-dom';
import { styledComponent } from 'lib/styled_component';

interface IProps {
  disabled?: boolean;
}

const StyledLink = styledComponent(Link)`
    text-decoration: none;
    color: inherit;

    pointer-events: ${(props: IProps) => (props.disabled ? 'none' : 'auto')};

    &:link,
    &:focus,
    &:visited,
    &:hover &:active {
        color: inherit;
        text-decoration: none;
        cursor: pointer;
    }
`;

export default StyledLink;
